import http from './http';

// Service de l'écran « Blocs affichés » (projet stats-audience-graphdebate_P3, ticket B10_02).
//
// Les compteurs d'application du forum (page_list / page_profile / page_group / group_list /
// search / inbox — StatObject product graphdebate) mesurent des FABRICATIONS DE BLOCS par le
// moteur, pas de l'audience (D22/D27 B+F). Métrique interne : ces endpoints n'existent qu'en
// suadmin, jamais côté client.
//
// http.js préfixe déjà /api et ajoute le header Authorization (gc_token). Signature réelle de
// http.get = un seul argument `path` (pas d'objet { params }) → query string construite à la
// main. Calque funnelService.js.

const BASE = '/suadmin/blocs-affiches';

// ⛔ GARDE « HTTP 200 + { gcCode: 410 } » = session expirée, PAS une donnée.
// routes.js pose `suadmin.use(auth.ensureAuthenticated)` AVANT `ensureAdmin`, et ce middleware
// répond 200 + gcCode sur un JWT absent/expiré ; http.js ne lève que sur `!res.ok`. Sans cette
// garde, l'écran afficherait « aucune donnée » (des zéros crédibles) sur une session morte.
// Pattern : moderationDashboardService.rejectGcCode (allégé — service en lecture seule).
const SESSION_EXPIRED = 'session_expired';

function rejectGcCode(result) {
  if (result === undefined || result === null || typeof result !== 'object') {
    const error = new Error('réponse inattendue du serveur (corps non JSON).');
    error.code = 'unexpected_response';
    throw error;
  }
  const hasErr = result.err && result.err !== 'undefined';
  if (result.gcCode || hasErr) {
    const error = new Error(
      'session expirée ou accès refusé. Recharge la page pour te reconnecter.'
    );
    error.code = SESSION_EXPIRED;
    error.body = result;
    throw error;
  }
  return result;
}

// Tenants forum (graphdebate.active) — le périmètre du sélecteur de site.
// → { sites: [{ _id, name, url }] }, triés par nom.
const getSites = () => http.get(`${BASE}/sites`).then(rejectGcCode);

// Totaux + série journalière par objet + indicateur Préchargement, pour UN site.
// from/to en jours calendaires `yyyy-MM-dd` (jours UTC inclus des deux côtés, cf. contrôleur).
// → { website_id, from, to, objects, totals, daily[], prefetch?, degraded? }
//   ⚠ `prefetch` ABSENT = lecteur StatLoad en panne (nommé dans `degraded`) ;
//     `prefetch.period_total: 0` = site non mesuré. Deux états distincts, deux affichages.
const getBlocsAffiches = (websiteId, from, to) => {
  const params = [`website_id=${encodeURIComponent(websiteId)}`];
  if (from) params.push(`from=${encodeURIComponent(from)}`);
  if (to) params.push(`to=${encodeURIComponent(to)}`);
  return http.get(`${BASE}?${params.join('&')}`).then(rejectGcCode);
};

export default { getSites, getBlocsAffiches, SESSION_EXPIRED };
export { getSites, getBlocsAffiches, SESSION_EXPIRED };
